export default __webpack_public_path__ + "static/media/S20.4ce6b4b1.png";